import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.div`
  max-width: 282px;
  padding: 120px 0;

  ${mobile(css`
    display: none;
  `)}

  h5.side-menu-title {
    ${setFontStyle("Head6", "Bold")};
    color: ${COLOR.grayScale_800};
  }

  p.desc {
    ${setFontStyle("Body8")};
    color: ${COLOR.grayScale_800};
    padding: 0 8px;
    margin: 19px 0 8px 0;
    word-break: keep-all;
  }
`;

const supportMenu = styled.div``;

const supportMenuSection = styled.section`
  margin-top: 24px;

  span.bullet {
    margin-right: 2px;
    vertical-align: text-top;
  }

  .text-button {
    margin-left: 4px;
  }
`;

const supportMenuSectionContainer = styled.div`
  display: flex;
`;

const dividingMiddleLine = styled.div`
  display: flex;
  align-items: center;
  margin: 40px 0;
  ${setFontStyle("Body8")};
  color: ${COLOR.grayScale_400};

  > .line {
    flex: 1;
    border-bottom: 1px solid ${COLOR.grayScale_200};
  }

  > .or-text {
    padding: 8px;
  }
`;

const guideMenu = styled.div``;

const guideMenuList = styled.ul`
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  padding: 0;

  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .icon-wrapper {
      width: 64px;
      padding: 15px;
      border: 1px solid ${COLOR.grayScale_300};
      border-radius: 300px;
      background-color: ${COLOR.white};
    }

    .text-button {
      margin-top: 8px;
      justify-content: center;

      .label {
        width: 72px;
        word-break: keep-all;
        text-align: center;
      }
    }
  }

  a:hover .icon-wrapper {
    background-color: ${COLOR.primaryBlue_10};
  }
`;

export default {
  container,
  supportMenu,
  supportMenuSection,
  supportMenuSectionContainer,
  dividingMiddleLine,
  guideMenu,
  guideMenuList,
};
